var __defProp = Object.defineProperty;
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var _handleResize, _CustomDialog_instances, handleClick_fn, handleKeyDown_fn, handleParamHintToOpen_fn;
import { C as Component } from "./component-cLJ9vlHA.js";
import { d as debounce, o as onAnimationEnd, h as isClickedOutside } from "./utilities-2Suih3Nm.js";
import { i as isKeyboardUser } from "./focus-D9T8n_CN.js";
import "./critical-Da0Dmhh9.js";
const _DialogOpenEvent = class _DialogOpenEvent extends CustomEvent {
  constructor() {
    super(_DialogOpenEvent.eventName, { bubbles: true });
  }
};
__publicField(_DialogOpenEvent, "eventName", "dialog:open");
let DialogOpenEvent = _DialogOpenEvent;
const _DialogCloseEvent = class _DialogCloseEvent extends CustomEvent {
  constructor() {
    super(_DialogCloseEvent.eventName, { bubbles: true });
  }
};
__publicField(_DialogCloseEvent, "eventName", "dialog:close");
let DialogCloseEvent = _DialogCloseEvent;
class CustomDialog extends Component {
  constructor() {
    super();
    __privateAdd(this, _CustomDialog_instances);
    __publicField(this, "requiredRefs", ["dialog"]);
    __privateAdd(this, _handleResize, debounce(() => {
      const { minWidth, maxWidth } = this;
      if (!minWidth && !maxWidth) return;
      const windowWidth = window.innerWidth;
      if (windowWidth < minWidth || windowWidth > maxWidth) this.closeDialog();
    }, 50));
    __publicField(this, "closeDialog", async () => {
      const { dialog, closeButton } = this.refs;
      if (!dialog.open) return;
      this.removeEventListener("click", __privateMethod(this, _CustomDialog_instances, handleClick_fn));
      this.removeEventListener("keydown", __privateMethod(this, _CustomDialog_instances, handleKeyDown_fn));
      dialog.classList.add("dialog-closing");
      await onAnimationEnd(dialog, void 0, {
        subtree: false
      });
      dialog.close();
      closeButton.setAttribute("aria-expanded", "false");
      this.querySelectorAll("custom-dialog").forEach((childDialog) => {
        if (childDialog === this) return;
        const child = childDialog.querySelector("dialog");
        if ((child == null ? void 0 : child.open) && typeof childDialog.closeDialog === "function") {
          childDialog.closeDialog();
        }
      });
      dialog.classList.remove("dialog-closing");
      this.dispatchEvent(new DialogCloseEvent());
    });
    __publicField(this, "toggleDialog", () => {
      if (this.refs.dialog.open) {
        this.closeDialog();
      } else {
        this.showDialog();
      }
    });
    this.openByDefault = this.getAttribute("data-open-by-default") === "true";
  }
  connectedCallback() {
    super.connectedCallback();
    if (this.minWidth || this.maxWidth) window.addEventListener("resize", __privateGet(this, _handleResize));
    __privateMethod(this, _CustomDialog_instances, handleParamHintToOpen_fn).call(this);
    this.openByDefault && this.showDialog();
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.minWidth || this.maxWidth) window.removeEventListener("resize", __privateGet(this, _handleResize));
  }
  async showDialog() {
    const { dialog, closeButton } = this.refs;
    if (dialog.open) return;
    const currentDialogOpen = document.querySelector("dialog[open]");
    if (currentDialogOpen && !(currentDialogOpen == null ? void 0 : currentDialogOpen.contains(this))) {
      const CustomDialog2 = currentDialogOpen.closest("custom-dialog, quick-view-dialog, cart-drawer");
      const isSearchDrawer = (CustomDialog2 == null ? void 0 : CustomDialog2.id) === "SearchDrawer";
      const isCartDrawer = (CustomDialog2 == null ? void 0 : CustomDialog2.id) === "CartDrawer";
      if (CustomDialog2 && !isSearchDrawer && !isCartDrawer) {
        await CustomDialog2.closeDialog();
      }
    }
    dialog.showModal();
    if (!isKeyboardUser() && document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
    closeButton.setAttribute("aria-expanded", "true");
    this.dispatchEvent(new DialogOpenEvent());
    setTimeout(() => {
      this.addEventListener("click", __privateMethod(this, _CustomDialog_instances, handleClick_fn));
      this.addEventListener("keydown", __privateMethod(this, _CustomDialog_instances, handleKeyDown_fn));
    });
  }
  get minWidth() {
    return Number(this.getAttribute("dialog-active-min-width"));
  }
  get maxWidth() {
    return Number(this.getAttribute("dialog-active-max-width"));
  }
}
_handleResize = new WeakMap();
_CustomDialog_instances = new WeakSet();
handleClick_fn = function(event) {
  const { dialog } = this.refs;
  const dialogInner = dialog.firstElementChild;
  const subDrawer = dialog.querySelector(".sub-drawer.open");
  const isSubDrawerActive = dialog.classList.contains("sub-drawer-active");
  const cartDrawerFeatureElement = dialog.querySelector("sub-drawer.open");
  if (isSubDrawerActive && !(event.target.closest("button") instanceof HTMLButtonElement)) {
    if (cartDrawerFeatureElement && isClickedOutside(event, subDrawer)) {
      cartDrawerFeatureElement.closeSubDrawer();
    }
  }
  if (isClickedOutside(event, dialogInner)) {
    this.closeDialog();
    if (cartDrawerFeatureElement) {
      cartDrawerFeatureElement.closeSubDrawer();
    }
  }
};
handleKeyDown_fn = function(event) {
  if (event.key !== "Escape") return;
  event.preventDefault();
  const { dialog } = this.refs;
  const isSubDrawerActive = dialog.classList.contains("sub-drawer-active");
  if (isSubDrawerActive) {
    const cartDrawerFeatureElement = dialog.querySelector("sub-drawer.open");
    if (cartDrawerFeatureElement) {
      cartDrawerFeatureElement.closeSubDrawer();
    }
    return;
  }
  this.closeDialog();
};
handleParamHintToOpen_fn = function() {
  const { dialog } = this.refs;
  const paramHintToOpen = dialog.getAttribute("param-hint-to-open");
  if (!paramHintToOpen) return;
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has(paramHintToOpen)) {
    this.showDialog();
  }
};
if (!customElements.get("custom-dialog")) {
  customElements.define("custom-dialog", CustomDialog);
}
let cachedScrollbarWidth = null;
if (typeof requestIdleCallback !== "undefined") {
  requestIdleCallback(() => {
    cachedScrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
  });
}
window.addEventListener("resize", () => {
  cachedScrollbarWidth = null;
}, { passive: true });
document.addEventListener(
  "toggle",
  (event) => {
    var _a, _b;
    if (event.target instanceof HTMLDialogElement || event.target instanceof HTMLDetailsElement) {
      if (event.target.hasAttribute("no-scroll")) {
        const { open } = event.target;
        if (open) {
          if (cachedScrollbarWidth === null) {
            cachedScrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
          }
          if (cachedScrollbarWidth > 0) {
            document.body.style.paddingRight = `${cachedScrollbarWidth}px`;
          }
          document.documentElement.setAttribute("no-scroll", "");
          (_a = Theme == null ? void 0 : Theme.lenis) == null ? void 0 : _a.stop();
          event.target.setAttribute("data-lenis-prevent", "");
        } else {
          document.documentElement.removeAttribute("no-scroll");
          document.body.style.paddingRight = "0";
          (_b = Theme == null ? void 0 : Theme.lenis) == null ? void 0 : _b.start();
          event.target.removeAttribute("data-lenis-prevent");
        }
      }
    }
  },
  { capture: true }
);
export {
  CustomDialog as C,
  DialogOpenEvent as D,
  DialogCloseEvent as a
};
